var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-custom",class:{ 'btn-sm': !_vm.editMode },on:{"click":_vm.deleteStoreUser}},[_c('a-icon',{attrs:{"icon":"Bin","height":`${_vm.editMode ? '21px' : '24px'}`}}),_c('span',{staticClass:"ml-1"},[_vm._v(" Usuń")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }